export default defineNuxtPlugin(() => {
  const route = useRoute()
  const authFlow = useAuthFlow()
  if (route.path !== '/') return

  if (route.query.createAccount) {
    authFlow.updateState({ authRequired: true, flow: 'signUp' })
  }
})
